import React, { useState, useEffect } from 'react';
import logo from '../images/soez_logo_white.svg';

const Navigation: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.pageYOffset > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-soez-blue/98' : 'bg-soez-blue/95'
      } backdrop-blur-md shadow-lg`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4 flex justify-between items-center">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          className="hover:opacity-80 transition-opacity"
        >
          <img src={logo} alt="SoEz Logo" className="h-16 w-16" />
        </button>

        <ul className="hidden md:flex gap-8">
          <li>
            <button
              onClick={() => scrollToSection('features')}
              className="text-white font-medium hover:text-soez-orange transition-colors"
            >
              Features
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('why-choose')}
              className="text-white font-medium hover:text-soez-orange transition-colors"
            >
              Why SoEz
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('use-cases')}
              className="text-white font-medium hover:text-soez-orange transition-colors"
            >
              Use Cases
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white font-medium hover:text-soez-orange transition-colors"
            >
              Contact
            </button>
          </li>
        </ul>

        <a
          href="https://app.soez.co.za"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-soez-orange text-white px-6 py-3 rounded-md font-semibold hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
        >
          Log In
        </a>
      </div>
    </nav>
  );
};

export default Navigation;
